import React from 'react';
import DoctorList from './DoctorList';
import { Typography } from '@mui/material';
const DoctorSection: React.FC = () => {
    return (
        <section >
                    {/* <Typography variant="h4" sx={{ fontSize: { xs: '1.5rem', sm: '2rem' } , mb:2, textAlign:{ xs: 'center', md: 'left' }}}>Doctor Management</Typography> */}

            <DoctorList />
        </section>
    );
};

export default DoctorSection;